import { formatPreciseDurationCompact } from "@src/appV2/redesign/utils/formatPreciseDurationCompact";
import { differenceInMilliseconds, differenceInSeconds } from "date-fns";

export function getShiftProgressAndWorkedTime(params: {
  clockInDate: Date;
  shiftStartDate: Date;
  shiftEndDate: Date;
  now: Date;
}) {
  // Input params
  const { clockInDate, shiftStartDate, shiftEndDate, now } = params;

  // Time elapsed calculations
  const elapsedTimeMs = differenceInMilliseconds(now, clockInDate);
  const elapsedSeconds = differenceInSeconds(now, clockInDate);

  // Duration calculations
  const totalShiftDurationMs = differenceInMilliseconds(shiftEndDate, shiftStartDate);
  const lateClockInDurationMs = differenceInMilliseconds(clockInDate, shiftStartDate);
  const remainingShiftDurationMs = totalShiftDurationMs - lateClockInDurationMs;

  const timeWorked = formatPreciseDurationCompact(elapsedSeconds);
  const progress = Math.min(elapsedTimeMs / remainingShiftDurationMs, 1);

  return { progress, timeWorked };
}
